import BackgroundStyle, { BackgroundTypeEnum } from "@features/share/theme-style/background";


export default function ThemeBackground({children, displaySetting}) {
  
  const {
    enable_overlay,
    overlay_color,
    type,
    blur: blurBackgroundSetting = 0,
  } = displaySetting?.background || {};
  
  const {background} = displaySetting || {};
  const styleBackgroundImage =
    type === BackgroundTypeEnum.IMAGE
      ? {
        width: `calc(100% + ${blurBackgroundSetting * 2}px) `,
        height: `calc(100% + ${blurBackgroundSetting * 2}px) `,
        transform: `translate(-${blurBackgroundSetting}px, -${blurBackgroundSetting}px)`,
      }
      : "";
  return <>
    <BackgroundStyle backgroundSetting={background}/>
    <div>
      <div
        style={{
          position: "fixed",
          width: "100%",
          height: "100%",
          top: "0px",
          left: "50%",
          // maxWidth: "700px",
          transform: "translateX(-50%)",
          overflow: "hidden",
        }}
      >
        <div
          className="w-full h-full background-image background-blur background-color"
          style={{
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            objectFit: "cover",
            ...styleBackgroundImage,
          }}
        ></div>
      </div>
      {/* {type === BackgroundTypeEnum.IMAGE && enable_overlay && (
        <div
          className="absolute top-0 block w-full h-full"
          style={{
            backgroundColor: overlay_color,
            zIndex: 2,
            // maxWidth: "700px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        ></div>
      )} */}
      {children}
    </div>
  </>
}